/**
 * @param 是否有权限 devicesInfo.errormessage
 * @param 是否点击过快 需判断上一次的操作时间
 * @param 调用 setenable
 */
import i18n from '@/lang';
import axios from 'axios';
import store from '@/store/index.js';
import { Message } from 'element-ui';
let controlCameraTimestamp = ref(new Date().getTime());
let controlMicTimestamp = ref(new Date().getTime());
export function judgeCanControl(type, devicesInfo) {
  let flag = true;
  const devicesId = type === 'video' ? devicesInfo.cameraId : devicesInfo.microphoneId;
  const deviceError = type == 'video' ? devicesInfo.cameraError === 'PERMISSION_DENIED' : devicesInfo.microphoneError === 'PERMISSION_DENIED';
  if (!devicesId) {
    // 权限验证
    if (deviceError) {
      store.state.guideObjShow = true;
    } else {
      type == 'video' ? Message.error('No cameras available') : Message.error('No microphone available');
    }
    flag = false;
  }

  // 如果点击过快则不允许操作
  const controlTimestamp = type === 'video' ? controlCameraTimestamp.value : controlMicTimestamp.value;
  if (new Date().getTime() - controlTimestamp.value < 1000) {
    Message.warning(i18n.t('commonFunction.notOperateFrequery'));
    flag = false;
  } else {
    type === 'video' ? controlCameraTimestamp.value = new Date().getTime() : controlMicTimestamp.value = new Date().getTime();
  }
  return flag;
}
export async function controlCamera(rtc, devicesInfo, val, callback) {
  const canExecute = judgeCanControl('video', devicesInfo);
  if (!canExecute || !rtc) return;
  // mute 的值和 enable 是相反的
  store.state.selfVideo = val;
  await rtc.setEnabled(val, 'video', info => {
    if (info === 'failed') {
      store.state.selfVideo = !store.state.selfVideo;
      Message.warning(i18n.t('common.operationFailed'));
    }
    if (callback && typeof callback == 'function') callback(info);
  }, {
    controlsMedia: val
  });
}
export async function controlDevicePublish(rtc, type, track = []) {
  if (!rtc) return;
  let result = 'success';
  const method = type === 'publish' ? 'publish' : 'unpublish';
  try {
    var _rtc$_client;
    await ((_rtc$_client = rtc._client) === null || _rtc$_client === void 0 ? void 0 : _rtc$_client[method](track));
  } catch (e) {
    result = 'failed';
    console.log(e);
  }
  return result;
}
export async function controlAudio(rtc, devicesInfo, val, callback) {
  if (!rtc) return;
  const canExecute = judgeCanControl('audio', devicesInfo);
  if (!canExecute || !rtc) return;
  // mute 的值和 enable 是相反的
  store.state.selfAudio = val;
  rtc.setEnabled(val, 'audio', info => {
    if (info === 'failed') {
      store.state.muteSelfAudio = !store.state.muteSelfAudio;
      Message.warning(i18n.t('common.operationFailed'));
    }
    if (callback && typeof callback == 'function') callback(info);
  }, {
    controlsMedia: val
  });
}
export function controlOtherCamera() {}
export function controlOtherAudio() {}
export function changeBehaviorStatus(info) {
  const {
    rtilCode,
    realPartyCode,
    key,
    value
  } = info;
  if (!rtilCode || !realPartyCode) return;
  const params = [{
    mark: rtilCode + '',
    annotation: realPartyCode,
    key,
    value,
    notify: true
  }];
  axios.post('/partyline-backend/behavior/noLogin/setList', params).then(res => {});
}
export function changeNickname(info, callback) {
  const {
    senderRtilCode,
    toRtilCode,
    nickName,
    partyCode
  } = info;
  if (!senderRtilCode || !toRtilCode || !partyCode) return;
  let params = {};
  let url = '';
  if (senderRtilCode == toRtilCode) {
    params = [{
      mark: toRtilCode + '',
      annotation: partyCode,
      key: 'nickName',
      notify: true,
      value: nickName,
      // 去掉首尾空格
      initiator: senderRtilCode
    }];
    url = '/partyline-backend/behavior/noLogin/setList';
  } else {
    params = {
      mark: toRtilCode + '',
      annotation: partyCode,
      key: 'nickName',
      notify: true,
      value: nickName,
      // 去掉首尾空格
      initiator: senderRtilCode,
      durable: true
    };
    url = `/partyline-backend/partyAction/controlBehavior?partyCode=${partyCode}`;
  }
  axios.post(url, params).then(res => {
    if (callback && typeof callback == 'function') callback(res);
  });
}
export function controlDeviceBehavior(info, callback) {
  const {
    senderRtilCode,
    type,
    value,
    partyCode,
    toRtilCode,
    origin,
    notChangeStatus
  } = info;
  if (!senderRtilCode || !type || !partyCode || !toRtilCode) return;
  let params = null;
  let url = '';
  if (type === 'camera') {
    store.state.cameraStatus[toRtilCode] = value;
  } else {
    store.state.micStatus[toRtilCode] = value;
  }
  if (senderRtilCode == toRtilCode) {
    params = [{
      mark: senderRtilCode + '',
      annotation: partyCode,
      key: type,
      value,
      notify: true
    }];
    url = '/partyline-backend/behavior/noLogin/setList';
  } else {
    params = {
      mark: toRtilCode + '',
      annotation: partyCode,
      key: type,
      notify: true,
      value,
      initiator: senderRtilCode,
      durable: true,
      origin
    };
    url = `/partyline-backend/partyAction/controlBehavior?partyCode=${partyCode}`;
  }
  axios.post(url, params).then(res => {
    if (!res) return;
    if (res.data.errorCode !== '0x0') {
      if (!notChangeStatus) type === 'camera' ? store.state.cameraStatus[toRtilCode] = !value : store.state.micStatus[toRtilCode] = !value;
    }
    if (callback && typeof callback == 'function') callback(res);
  }).catch(e => {
    if (!notChangeStatus) type === 'camera' ? store.state.cameraStatus[toRtilCode] = !value : store.state.micStatus[toRtilCode] = !value;
  });
}
export function controlDeviceAudioOrVideo(info, callback) {
  const {
    type,
    value,
    partyCode,
    rtilCode
  } = info;
  if (!type || !partyCode || !rtilCode) return;
  const url = type === 'audio' ? '/partyline-backend/commonParty/videoSetting/audio' : '/partyline-backend/commonParty/videoSetting/video';
  const params = {
    partyCode,
    rtilCode,
    enable: value
  };
  axios.post(url, params).then(res => {
    if (callback) callback(res);
  }).catch(e => {
    console.log(e);
  });
}